export default __webpack_public_path__ + "static/N0147-ae3ef80d045784c09505322bd74fe96a.png";